import React, { useRef } from 'react';
import { Toast } from 'primereact/toast';
import AdminLayout from '../../layouts/admin.layout';
import { useOrders } from '../hooks';
import { OrdersTable, DateRangeSelector } from '../components';
import { DateRangeParams } from '../types';
import './orders.screen.css';

const OrdersScreen: React.FC = () => {
  const { orders, loading, error, fetchOrdersByDateRange, removeOrder } = useOrders();
  const toast = useRef<Toast>(null);

  // Mostrar mensaje de error
  const showError = (message: string) => {
    toast.current?.show({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 3000
    });
  };

  // Manejar búsqueda por rango de fechas
  const handleSearch = async (params: DateRangeParams) => {
    try {
      const success = await fetchOrdersByDateRange(params);
      if (!success) {
        showError('No se pudieron cargar las órdenes');
      }
    } catch (err) {
      showError('Error al buscar órdenes');
    }
  };

  // Manejar eliminación de orden
  const handleDelete = async (id: number): Promise<boolean> => {
    try {
      const success = await removeOrder(id);
      if (!success) {
        showError('No se pudo eliminar la orden');
        return false;
      }
      return true;
    } catch (err) {
      showError('Error al eliminar la orden');
      return false;
    }
  };

  return (
    <AdminLayout>
      <div className="orders-screen">
        <Toast ref={toast} />

        <DateRangeSelector 
          onSearch={handleSearch}
          loading={loading}
        />

        {error && (
          <div className="error-message">
            <p>{error}</p>
          </div>
        )}

        <OrdersTable 
          orders={orders} 
          loading={loading}
          onDelete={handleDelete}
        />
      </div>
    </AdminLayout>
  );
};

export default OrdersScreen;
